export interface FormAddress {
  formName: string;
  apiType: string;
}
export const formAddressTypes: FormAddress[] = [
  { formName: 'province', apiType: 'administrative_area_level_1' },
  { formName: 'suburb', apiType: 'sublocality_level_2' },
  { formName: 'suburb', apiType: 'sublocality_level_1' },
  { formName: 'city', apiType: 'locality' },
  { formName: 'postal_code', apiType: 'postal_code' },
];
